export enum ApplicationPaymentPageDisplayType {
    hidden='HIDDEN',
    readOnly='READ_ONLY',
    edit='EDIT',
}
